import React from "react";
import Navbar from "../../Components/Navbar";
import Header from "../../Components/Header";
import { Container, Typography } from "@mui/material";
import Footer from "../../Components/Footer";
import PageTitle from "../../Components/PageTitle";
import LibraryFacilityBanner from "../../assets/LibraryFacility.png";

const LibraryFacility = () => {
  return (
    <>
      <Navbar />
      <PageTitle
        title="Library Facility - Shree Mangalam School"
        description="Explore the well-equipped library at Shree Mangalam School. A peaceful and resource-rich environment supporting RIMC, Sainik School, and Military School exam preparation."
        url="/library-facility"
        keywords="library facility, school library, study resources, RIMC exam books, Sainik school preparation material"
      />
      <Header image={LibraryFacilityBanner} alt={"Library Facility Banner"} />
      <Container sx={{ mb: 5, mt: 5 }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            fontSize: "30px",
            letterSpacing: 1,
            color: "#065A79",
            fontWeight: "bold",
          }}
          gutterBottom
        >
          Library Facility – A Gateway to Knowledge
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 3,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          At Shree Mangalam School, we believe that books are
          windows to the world. Our well-stocked library is a center of
          learning, imagination, and discovery for students of all ages.
          Designed to support both academic excellence and the joy of reading,
          our library offers a rich collection of textbooks, reference
          materials, storybooks, magazines, newspapers, and digital resources.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 3,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          We aim to create a vibrant reading culture where students not only
          excel in their studies but also develop a lifelong love for learning,
          critical thinking, and creativity. The calm and welcoming environment
          of our library helps students focus, explore new ideas, and expand
          their horizons beyond the classroom.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Extensive Collection of Books:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          From academic textbooks to inspiring biographies, fiction,
          non-fiction, encyclopedias, and exam preparation materials — our
          library caters to every student’s needs.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Digital Learning Resources:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          We offer access to e-books, educational videos, and online journals to
          help students stay updated with the latest information and global
          knowledge.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Comfortable Reading Environment:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Our library is designed with comfortable seating, quiet zones, and
          bright lighting to encourage peaceful and focused reading.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Daily Newspapers and Magazines:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Students stay informed about current events, general knowledge, and
          new developments through regular access to newspapers and magazines.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Research and Project Support:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          The library is a perfect resource center for students working on
          assignments, projects, and self-study, providing guidance and
          reference materials.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Reading Encouragement Programs:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          We organize reading challenges, book fairs, storytelling sessions, and
          library activities to promote reading habits among students.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Library Periods:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Regularly scheduled library periods are part of the timetable, giving
          every student time to explore books and broaden their minds.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Friendly Librarian Assistance:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Our trained librarian helps students find the right books, guides
          research work, and motivates children to discover the joy of reading.
        </Typography>
      </Container>
      <Footer />
    </>
  );
};

export default LibraryFacility;
